import React from "react";
import Section from "./WizardComponents/section";
import styles from "./fittingInstructions.module.css";
import { returnImageSrcList } from "../../services/sportsBraProcessingService";

const FittingInstructions = (props) => {
  const { breastSupportRecommended } = props;

  /*Set video or image props*/
  let videoCorrectFitBand = require(`../../assets/video/Band CT Correct.mp4`);
  let videoIncorrectFitBand = require(`../../assets/video/Band CT Too Big.mp4`);
  let videoPosterCorrectBand = require(`../../assets/video/Band CT Correct.png`);
  let videoPosterIncorrectBand = require(`../../assets/video/Band CT Too Big.png`);

  let videoCorrectFitStrap = require(`../../assets/video/Strap CT Correct.mp4`);
  let videoIncorrectFitStrap = require(`../../assets/video/Strap CT Too Big.mp4`);
  let videoPosterCorrectStrap = require(`../../assets/video/Strap CT Correct.png`);
  let videoPosterIncorrectStrap = require(`../../assets/video/Strap CT Too Big.png`);


  let imageListCorrectCup = returnImageSrcList(breastSupportRecommended, "Cup").correctFit;
  let imageListIncorrectCup = returnImageSrcList(breastSupportRecommended, "Cup").incorrectFit;
  let imageListCorrectMaterial = returnImageSrcList(breastSupportRecommended, "Material").correctFit;
  let imageListIncorrectMaterial = returnImageSrcList(breastSupportRecommended, "Material").incorrectFit;
  let imageListCorrectUnderwire = returnImageSrcList(breastSupportRecommended, "Underwire").correctFit;
  let imageListIncorrectUnderwire = returnImageSrcList(breastSupportRecommended, "Underwire").incorrectFit;

  return (
    <div className={styles.container}>
      <Section
        title="Band"
        correct={[
          "Feels firm around the trunk",
          "Has firm resistance when the band is pulled away from the trunk",
          "Stays in place when you raise your arms",
        ]}
        incorrect={[
          "Too small: Feels too tight around trunk",
          "Too big: Feels loose around the trunk, and",
          "Has no resistance when the band is pulled away from the trunk, and",
          "There are wrinkles in the material, and",
          "Slides up and down when you raise your arms",
        ]}
        tips={[
          "If too tight, go up a band size.",
          "If too loose, go down a band size.",
        ]}
        videoSrcCorrect={videoCorrectFitBand}
        posterCorrect={videoPosterCorrectBand}
        videoSrcIncorrect={videoIncorrectFitBand}
        posterIncorrect={videoPosterIncorrectBand}
        part="Band"
      />

      <Section
        title="Cups"
        correct={[
          "All your breast tissue is contained within your bra cup (high neckline)",
          "Crop top: breasts feel compressed against the chest wall",
          "Encapsulation: breasts feel lifted compared to bare breasted",
          "Hybrid: breasts feel compressed and lifted",
        ]}
        incorrect={[
          "Too small: Feels uncomfortable, breast tissue bulging out of the front or side of the cup or sitting within the band of the bra",
          "Too big: Wrinkles in the cup or gaps between bra cup and breast tissue",
          "Crop Top and Hybrid bras: breasts NOT compressed against the chest wall",
          "Encapsulation: breasts sagging, not lifted compared to bare breasted",
        ]}
        tips={[
          "If bulging, go up a cup size.",
          "If wrinkling/gapping, go down a cup size.",
        ]}
        imageListCorrect={imageListCorrectCup}
        imageListIncorrect={imageListIncorrectCup}
      />

      <Section
        title="Straps"
        correct={[
          "Feels firm but comfortable on shoulders",
          "Does NOT easily slide off shoulders",
          "Firm resistance when lifting the strap away from the shoulders",
        ]}
        incorrect={[
          "Too small: feels too tight on the shoulders",
          "Too big: Straps feel loose on the shoulders and easily slide off shoulders, and",
          "Have loose resistance when strap is pulled away from shoulder",
        ]}
        tips={[
          "If too tight, lengthen them.",
          "If too loose, shorten them.",
          "If not adjustable, choose a style with adjustable straps.",
        ]}
        videoSrcCorrect={videoCorrectFitStrap}
        posterCorrect={videoPosterCorrectStrap}
        videoSrcIncorrect={videoIncorrectFitStrap}
        posterIncorrect={videoPosterIncorrectStrap}
        part="Straps"
      />

      <Section
        title="Material"
        correct={[
          "Strong, breathable material that wicks sweat away from the body and feels smooth and comfortable against your skin",
          "Inner surface of bra has smooth seams, hooks/clips",
        ]}
        incorrect={[
          "Weak, stretchy material that stays wet and feels scratchy or uncomfortable against your skin",
          "Inner surface of bra has raised or abrasive  seams, hooks/clips",
        ]}
        imageListCorrect={imageListCorrectMaterial}
        imageListIncorrect={imageListIncorrectMaterial}
      />

      <Section
        title="Underwire"
        correct={["Sits on your breastbone and ribs."]}
        incorrect={["Sits on breast tissue at front or sides."]}
        tips={["Choose a different underwire style or a non-underwire bra."]}
        imageListCorrect={imageListCorrectUnderwire}
        imageListIncorrect={imageListIncorrectUnderwire}
      />
    </div>
  );
};

export default FittingInstructions;
